import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { isUnlimitedSpeakingValue, normalizeUnlimitedSpeakingValue } from './speaking-number-policy';
import { Result } from '@digibricks/core';
export var SpeakingMaxAttempts = /*#__PURE__*/function () {
  function SpeakingMaxAttempts() {
    _classCallCheck(this, SpeakingMaxAttempts);
  }

  _createClass(SpeakingMaxAttempts, null, [{
    key: "isUnlimited",
    value: function isUnlimited(value) {
      return isUnlimitedSpeakingValue(value);
    }
  }, {
    key: "normalize",
    value: function normalize(value) {
      return normalizeUnlimitedSpeakingValue(value);
    }
  }, {
    key: "create",
    value: function create(value) {
      var normalizedValue = this.normalize(value);

      if (normalizedValue === this.Unlimited) {
        return Result.ok(normalizedValue);
      }

      if (!Number.isInteger(normalizedValue) || normalizedValue < 1) {
        return Result.fail('Speaking max attempts must be a positive integer or unlimited');
      }

      return Result.ok(normalizedValue);
    }
  }]);

  return SpeakingMaxAttempts;
}();

_defineProperty(SpeakingMaxAttempts, "Unlimited", -1);

_defineProperty(SpeakingMaxAttempts, "Default", 3);